import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitPopUpData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  selectedDataList?: any;
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}
const SN_PRD_WRK_REG_002_TEX_POP_001 = forwardRef(
  (
    { selectedDataList, selectedData, modalRef }: popupProps,
    ref: React.Ref<any>
  ) => {
    //#region variable
    const { userInfo } = global();
    const [gridFocus, setGridFocus] = useState(false);
    const [popupParent, setPopupParent] = useState<any>(null);
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
    });
    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const searchData = searchRef.current.getFormdata();
        let lsChk: any = "2";
        if (searchData.cd_wh_rcv === "" || searchData.cd_wh_rcv === null) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "창고는 필수값 입니다." };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        onSave();
      },
      getSelectedRow: () => [
        gridRefs.current["grid2"].current.getChange() || [],
      ],
    }));
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useEffect(() => {
      const fetchform = async () => {
        try {
          //getinitformdata식으로 바껴야함
          const rtn: any = await getInitPopUpData(
            "SN_PRD_WRK_REG_002_TEX_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormData(mergedData); // 조회조건 초기값
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          await onSearch();
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);

    const onInsert = () => {
      try {
        const newRow = {};
        gridRefs.current["grid1"].current?.addRow(newRow);
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };
    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const groupMap = new Map<string, any>();

          for (const row of selectedDataList) {
            const key = [row.no_wo, row.cd_var1, row.cd_var2, row.no_work].join(
              "|"
            );

            if (!groupMap.has(key)) {
              groupMap.set(key, {
                no_wo: row.no_wo,
                cd_var1: row.cd_var1,
                cd_var2: row.cd_var2,
                no_work: row.no_work,
                qt_b: Number(row.qt_b ?? 0),
              });
            }
          }

          const groupedList = Array.from(groupMap.values());
          const no_wo = groupedList[0]?.no_wo;
          const no_work_set = groupedList[0]?.no_work;
          const cd_var1 = groupedList.map((i) => i.cd_var1).join(",");
          const cd_var2 = groupedList.map((i) => i.cd_var2).join(",");
          const no_work = groupedList.map((i) => i.no_work).join(",");
          const qt_b = groupedList.map((i) => i.qt_b).join(",");
          const cd_item = groupedList.map((i) => i.cd_item).join(",");
          const cd_dummy01 = groupedList.map((i) => i.cd_dummy01).join(",");

          const params = {
            id: "sn_prd_wrk_reg_002_tex_pop_01",
            params: {
              cd_firm: userInfo.cd_firm,
              no_wo: no_wo,
              cd_var1: cd_var1,
              cd_var2: cd_var2,
              qt_b: qt_b,
              no_work: no_work,
              no_work_set: no_work_set,
              cd_item: cd_item,
              cd_dummy01: cd_dummy01,
            },
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
            grid2: data[1] || [],
          });
          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus(true);
            gridRefs.current["grid1"].current.resetUpdate();
            gridRefs.current["grid2"].current.resetUpdate();
          } else {
            await onInsert();
          }
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    const onSave = async () => {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      const searchData = searchRef.current.getFormdata();
      const grid = gridRefs.current["grid2"].current?.getChange();

      let grid2Count = 0;
      gridRefs.current["grid2"].current.forEachNode((node: any) => {
        grid2Count += 1;
      });
      const mtlQtiohDeletes: any[] = [];
      if (grid2Count === 0) {
        mtlQtiohDeletes.push({
          cd_firm: userInfo.cd_firm,
          no_io: selectedDataList[0].no_work.concat("_B"),
        });
      }
      const mtlQtiohChanges = {
        insert: [],
        update: [],
        delete: mtlQtiohDeletes,
        modifiedRowcount: mtlQtiohDeletes.length,
      };
      const payload = {
        id: "wo_tex_update_yn_isu",
        params: {
          cd_firm: userInfo.cd_firm,
          no_wo: selectedData.no_wo,
          yn_rcv_b: searchData.yn_rcv_b,
        },
      };
      await fnGetTableById(payload);
      const SaveData = {
        prd_workvariantb_tex: grid,
        mtl_qtioh: mtlQtiohChanges,
      };
      await fnSave("SN_PRD_WRK_REG_002_TEX_SAVE_01_POP", SaveData);
    };
    //#endregion

    const onBtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };
    const onAddRow = async () => {
      try {
        if (gridRefs.current["grid1"].current.getDisplayedRowCount() === 0)
          return;
        const rowIndex =
          gridRefs.current["grid1"].current.focusedRowNode().rowIndex;
        let maxNoLine =
          gridRefs.current["grid2"].current.getMaxValue("no_line");
        let maxNoLineVar = 0;

        gridRefs.current["grid2"].current.forEachNode((node: any) => {
          const val = Number(node.data?.no_line_var ?? 0);
          if (val > maxNoLineVar) {
            maxNoLineVar = val;
          }
        });
        const searchData = searchRef.current.getFormdata();
        const newRow = {
          cd_firm: userInfo.cd_firm,
          no_work: selectedDataList[rowIndex].no_work,
          no_wo: selectedDataList[rowIndex].no_wo,
          no_style: selectedDataList[rowIndex].no_style,
          no_line: rowIndex + 1,
          no_line_var: maxNoLineVar + 1,
          cd_var1: selectedDataList[rowIndex].cd_var1,
          cd_var2: selectedDataList[rowIndex].cd_var2,
          dt_work: selectedDataList[rowIndex].dt_work,
          cd_item: selectedDataList[rowIndex].cd_item,
          cd_dummy01: selectedDataList[rowIndex].cd_dummy01,
          cd_biz: userInfo.cd_biz,
          cd_dept: userInfo.cd_dept,
          cd_gp: userInfo.cd_gp,
          cd_emp: userInfo.cd_emp,
          cd_wh: searchData.cd_wh_rcv,
          no_po: searchData.no_po,
        }; // 빈
        gridRefs.current["grid2"].current?.addRow(newRow);
      } catch (error: any) {}
    };
    //#region InitnewRowH

    const onDeleteRow = async () => {
      if (gridRefs.current["grid2"].current.getDisplayedRowCount() < 1) {
        return;
      }
      gridRefs.current["grid2"].current?.deleteSelectedRows();
      await new Promise((resolve) => setTimeout(resolve, 0));
      const footerData = gridRefs.current["grid2"].current?.getFooterData();
      const focusedCell = gridRefs.current["grid1"].current.focusedRowNode();
      focusedCell.setDataValue("qt_b", footerData.qt_b);
    };
    const onCellValueChanged = async (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;
      if (colId === "qt_b") {
        await setFooterDataToRow();
      }
    };
    const onFocusedRowChanged = async (event: any) => {
      const selectedRow = event;
      gridRefs.current["grid2"].current.applyFilters({
        cd_var1: selectedRow.cd_var1,
        cd_var2: selectedRow.cd_var2,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    };
    const setFooterDataToRow = () => {
      setTimeout(() => {
        const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
        const footerData = gridRefs.current["grid2"].current.getFooterData();
        if (focusedNodeH) {
          focusedNodeH.setDataValue("qt_b", footerData.qt_b);
        }
      }, 0);
    };
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCellValueChanged: onCellValueChanged,
          },
        },
      }),
      [columns, dataSources]
    );
    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
          />
          <SnTabHeader
            onBtnAddClick={onBtnsClick}
            onBtnDeleteClick={onBtnsClick}
          />
        </div>
        <div className="w-full h-full flex space-x-1">
          <div className="w-[48%] flex flex">
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{
                isEditable: true,
                rowSelection: "single",
                popupParent: popupParent,
              }}
              events={grids.grid1.events}
            />
          </div>
          <div className="w-full flex flex">
            <SnGrid
              ref={gridRefs.current["grid2"]} // Grid Name
              columnConfig={grids.grid2.columns} // 컬럼 설정 전달
              rowData={grids.grid2.dataSource} // Datasource
              etcProps={{
                isEditable: true,
                rowSelection: "single",
                popupParent: popupParent,
              }}
              events={grids.grid2.events}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WRK_REG_002_TEX_POP_001;
